<template>
    <layout>
        <template v-slot:header>
            <AppHead title="Returns to Manufacturers" />
            <h2>Returns to Manufacturers</h2>
            <flash-messages />
        </template>

        <template v-slot:default>
            <section class="mt-3 mb-5">
                <div class="table-responsive">
                    <DataTable :value="manufacturers" v-model:expandedRows="expandedItems"
                        class="p-datatable-sm admin-datatable" tableClass="border-left border-right border-bottom"
                        dataKey="manufacturer_id">
                        <Column field="manufacturer" header="Manufacturer" class="pl-3" headerClass="pl-3">
                            <template #body="slotProps">
                                <inertia-link class="m-text-nowrap" :href="route(
                                    'admin.returns.manufacturer',
                                    slotProps.data.id || 0)">
                                    <span>{{ slotProps.data.name }}</span>
                                </inertia-link>
                                <span> - {{ slotProps.data.short_name }}</span>
                            </template>
                        </Column>

                        <Column field="pending_count" header="Pending Items" headerClass="column-text-right"
                            class="text-center">
                        </Column>

                        <Column field="returns_count" header="Completed Returns" headerClass="column-text-right"
                            class="text-center">
                        </Column>

                    </DataTable>
                </div>
            </section>
        </template>
    </layout>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import FlashMessages from '@/Shared/FlashMessages'
import BreadCrumbs from '@/Shared/BreadCrumbs'

export default {
    components: {
        Icon,
        Layout,
        FlashMessages,
        BreadCrumbs
    },
    props: {
        manufacturers: Array
    },
}
</script>

<style>
.p-column-header-content {
    display: block !important;
}
</style>
